module.exports = __webpack_public_path__ + "static/media/tl_unknown.8dac4a52.svg";